import { z } from 'zod';

import { CompanyId, LosId, TaskId, TeamId, UserId } from '../BrandedIds';
import { TaskType } from '../tasks/Task';
import { TaskStatus } from '../tasks/TaskStatus';
import { zodTemporalInstant, zodTemporalPlainDate } from '../Temporal';
import { zodBrandedString, zodBrandedUuid } from '../utils';

export const ExportableTask = z
  .object({
    id: zodBrandedUuid<TaskId>(),
    companyId: zodBrandedUuid<CompanyId>(),
    loanId: zodBrandedString<LosId>().optional(),

    type: TaskType,
    status: TaskStatus,

    title: z.string().optional(),
    details: z.string(),

    dueDate: zodTemporalPlainDate.optional(),
    completedAt: zodTemporalInstant.optional(),

    assignees: z.array(zodBrandedUuid<UserId>()).optional(),
    teamAssignees: z.array(zodBrandedUuid<TeamId>()).optional(),

    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'Task' });

export type ExportableTask = z.infer<typeof ExportableTask>;
